import { gql } from 'apollo-angular'

export const DELETE_NOTIFICATION_OPT_OUT = gql`
  mutation DeleteNotificationOptOut($id: Int!) {
    deleteMagazineNotificationOptOut(id: $id) {
      id
    }
  }
`
